import React from "react";
import { ErrorMessage, Field } from "formik";

function InputField({ id, label = "No label" }) {
  return (
    <div className="form-group">
      <label htmlFor={id}>{label}</label>
      <Field id={id} name={id} className="form-control" />
      <ErrorMessage name={id} component="div" className="text-danger" />
    </div>
  );
}

export default InputField;
